import React, { useState } from 'react';
import Slider from "react-slick";
import featureDataEN from '../data/en/feature.json';
import featureDataTH from '../data/th/feature.json';
import featureDataVN from '../data/vn/feature.json';
import featureDataAR from '../data/ar/feature.json';
let featureData:any={}
let cacheFeature:any=",";
export default function FeatureItem(props:any){
    if(sessionStorage.getItem("feature")){
      cacheFeature=  sessionStorage.getItem("feature")
    }
    let volume:any = sessionStorage.getItem("capacity")
    let arrData:any = [""]
    if(sessionStorage.getItem("lang")==="th"){
      featureData = featureDataTH
    }else if(sessionStorage.getItem("lang")==="vn"){
      featureData = featureDataVN
    }else if(sessionStorage.getItem("lang")==="ar"){
      featureData = featureDataAR
    }else{
      //if(parseInt(volume)===1){
        
        featureData = featureDataEN.filter(function(item:any, index:number){ 
          return  item.id >= 0;
        });
        console.log(featureData)
      // }else{
      //   featureData = featureDataEN.filter(function(item:any, index:number){ 
      //     return  item.id <3;
      //   });
       
      // }
      
    }
    const [featureLists, setfeatureLists] = useState(featureData);
    const [module, setModule] = useState(false);
    const [selectedItem, setSelectedItem] = useState(cacheFeature?.split(','));
    const settings:any = {
      arrows:true,
      dots: true,   
      slidesToShow:3,
      slidesToScroll: 1,
      className: "center",
      centerPadding: "0px",
      centerMode: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll:1,
            initialSlide: 1,
            infinite: false,
            dots: true,
            centerPadding: "80px",
            centerMode: true,
            arrows:false, 
          }
        },
        {
          breakpoint: 840,
          settings: {
            slidesToShow: 1,
            slidesToScroll:1,
            initialSlide: 1,
            infinite: false,
            dots: true,
            centerPadding: "180px",
            centerMode: true,
            arrows:false, 
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll:1,
            initialSlide: 1,
            infinite: false,
            dots: true,
            centerPadding: "80px",
            centerMode: true,
            arrows:false, 
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1, 
            centerPadding: "32px",
            centerMode: true,
            arrows:false,
            infinite: false
          }
        }
      ]
    };
   
    const onSelectRadio=(e:any)=>{
      const {value} = e.target 
      if(e.target.checked){
        let newArr:any = [...selectedItem,value]
        let filtered:any = newArr.filter(function(item:any, index:number){ 
          if(value==="0"){
            return item !== ""&&item === "0";
          }else{
            return item !== ""&&item !== "0";
          }
         
        });
        setSelectedItem(filtered)
        setModule(true)
        props.onSelectFeature(filtered)
        
      }else{
        let filtered:any = selectedItem.filter(function(item:any, index:number){ 
          return item !== value&&item !== "";
        });
        setSelectedItem(filtered)
        setModule(false)
        props.onSelectFeature(filtered)
      }
    }
    const onSelectItem=(id:string)=>{
      if(!selectedItem.includes(id)){
        let newArr:any = [...selectedItem,id]
        
        let filtered:any = newArr.filter(function(item:any, index:number){ 
          if(id==="0"){
            return item !== ""&&item === "0";
          }else{
            return item !== ""&&item !== "0";
          }
        });
        setSelectedItem(filtered)
        setModule(true)
        props.onSelectFeature(filtered)
         
      }else{
        
        let filtered:any = selectedItem.filter(function(item:any, index:number){ 

          return item !== id&&item !== "";
        });
        setSelectedItem(filtered)
        setModule(false)
        props.onSelectFeature(filtered).
        clearFeature(id)
      }
     
    }
     
    return (
      <>
      <Slider {...settings}>
      {
        featureLists.map((item:any,key:number)=>
          <div className={`feature-item m-auto ${((parseInt(item.id)>=3&&parseInt(volume)===2))?"noClick":""} ${(selectedItem.includes(item.id.toString()))?"bg-red":""}`} key={`featue-${item.id}`} onClick={()=>onSelectItem(item.id.toString())}>
              <div className="images">
                  <img src={item.image} alt=""/>
              </div>
              <div className={`title-block  ${(selectedItem.includes(item.id.toString()))?"bg-red":""}`} >
              <div className="m-auto display-inline-block py-2">
                  <input type="checkbox"  name="checkbox" id={`a-opt${item.id}`} className='my-checkbox-x2' value={item.id} checked={(selectedItem.includes(item.id.toString()))?true:false} onChange={onSelectRadio}/>
                  <label htmlFor={`a-opt${item.id}`} className="checkbox">{item.name}</label>
              </div>
              </div>
          </div>
        )
      }
      </Slider>
      </>
    );
  }
